export const dialogIds = {
  ADD_NEW_PAYMENT_METHOD: 'add-new-payment-method',
  EDIT_PAYMENT_METHOD: 'edit-payment-method',
  REPLACE_PAYMENT_METHOD: 'replace-payment-method',
  REMOVE_PAYMENT_METHOD: 'remove-payment-method',
  CANCEL_SUBSCRIPTION: 'cancel-subscription',
};
